(() => {
  'use strict';

  const cleanCartIcon = '<svg viewBox="0 0 28 24" aria-hidden="true"><path d="M1.5 6h5M4 3.5v5M9 4h2l2.1 10.2a2 2 0 0 0 2 1.6h7.1a2 2 0 0 0 1.9-1.5L26 7H12M16.5 20a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const productPriceCache = new Map();

  const productPage = () => Boolean(document.querySelector('#MainContent[data-template="product"]'));

  const formatMoney = (cents) => new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: window.Shopify?.currency?.active || 'EUR',
  }).format((Number(cents) || 0) / 100);

  const nearbyPrice = (button) => {
    if (button.dataset.productPrice) return button.dataset.productPrice;
    const scope = button.closest('.mb-clean-product-card, .mb-v126-maker-footer, .card-wrapper, .mbf-row, .mb-fund-slide, .mb-category-card, .mb-fund-list-card, .mb-gift-result-card, .mb-book-card, .mb-discovery__featured-card') || button.parentElement;
    const price = scope?.querySelector('.mb-clean-product-card__price, .mb-v126-maker-price, .price-item--sale:not(.hidden), .price-item--regular, [data-mb-product-price]');
    return price?.textContent?.replace(/\s+/g, ' ').trim() || '';
  };

  const renderPriceCart = (button, price = '') => {
    if (price) button.dataset.productPrice = price;
    const displayedPrice = button.dataset.productPrice || price;
    button.classList.add('mb-price-cart-button');

    if (button.matches('[data-mb-quick-add]')) {
      button.innerHTML = `<span class="mb-price-cart-button__price">${displayedPrice || 'Prijs laden…'}</span>${cleanCartIcon}`;
    } else {
      let priceNode = button.querySelector('.mb-price-cart-button__price');
      if (!priceNode) {
        priceNode = document.createElement('span');
        priceNode.className = 'mb-price-cart-button__price';
        button.prepend(priceNode);
      }
      priceNode.textContent = displayedPrice || 'Prijs laden…';
    }
    button.closest('.mb-clean-product-card, .mb-v126-maker-footer, .card-wrapper, .mbf-row, .mb-fund-slide, .mb-category-card, .mb-fund-list-card, .mb-gift-result-card, .mb-book-card, .mb-discovery__featured-card')?.classList.add('mb-price-cart-applied');
  };

  const fetchButtonPrice = async (button) => {
    const handle = button.dataset.productHandle || productHandle(button.dataset.productUrl || button.closest('.card-wrapper, .mb-discovery__featured-card')?.querySelector('a[href*="/products/"]')?.href || '');
    if (!handle) return;
    try {
      let request = productPriceCache.get(handle);
      if (!request) {
        request = fetch(`/products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } })
          .then((response) => {
            if (!response.ok) throw new Error('Prijs niet beschikbaar');
            return response.json();
          });
        productPriceCache.set(handle, request);
      }
      const product = await request;
      const variant = product.variants?.find((candidate) => candidate.available) || product.variants?.[0];
      if (!variant) return;
      renderPriceCart(button, formatMoney(variant.price));
    } catch (_error) {
      const placeholder = button.querySelector('.mb-price-cart-button__price');
      if (placeholder && placeholder.textContent === 'Prijs laden…') placeholder.textContent = 'Prijs';
    }
  };

  const priceObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      priceObserver.unobserve(entry.target);
      fetchButtonPrice(entry.target);
    }), { rootMargin: '300px' })
    : null;

  const enhancePriceCart = (button) => {
    const price = nearbyPrice(button);
    renderPriceCart(button, price);
    if (!price) {
      if (priceObserver) priceObserver.observe(button);
      else fetchButtonPrice(button);
    }
  };

  const productHandle = (href) => {
    try {
      const match = new URL(href, window.location.origin).pathname.match(/^\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (_error) {
      return '';
    }
  };

  const buttonMarkup = (handle) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'mb-quick-add';
    button.dataset.mbQuickAdd = '';
    button.dataset.productHandle = handle;
    button.dataset.defaultLabel = 'Toevoegen aan winkelmandje';
    button.setAttribute('aria-label', button.dataset.defaultLabel);
    button.setAttribute('title', button.dataset.defaultLabel);
    button.innerHTML = cleanCartIcon;
    return button;
  };

  const updateCartLabels = async () => {
    const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } }).then((response) => response.json());
    document.querySelectorAll('.mb-cart-label').forEach((label) => {
      label.innerHTML = `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 4h2l2.1 10.1a2 2 0 0 0 2 1.6h7.8a2 2 0 0 0 2-1.6L20.4 8H7M10 20a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm9 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg><span>Winkelmandje (${cart.item_count})</span>`;
      label.classList.toggle('mb-cart-label--has-items', cart.item_count > 0);
      label.setAttribute('aria-label', `Winkelmandje met ${cart.item_count} artikelen`);
    });
    const mobileCart = document.querySelector('.mb-mobile-actions a[href*="/cart"]');
    let mobileCount = mobileCart?.querySelector('.mb-mobile-cart-count');
    if (cart.item_count > 0 && mobileCart && !mobileCount) {
      mobileCount = document.createElement('span');
      mobileCount.className = 'mb-mobile-cart-count';
      mobileCart.appendChild(mobileCount);
    }
    if (mobileCount) {
      if (cart.item_count > 0) mobileCount.textContent = String(cart.item_count);
      else mobileCount.remove();
    }

    document.querySelectorAll('.mb-unified-header__cart').forEach((cartLink) => {
      let count = cartLink.querySelector('.mb-unified-cart-count');
      if (cart.item_count > 0 && !count) {
        count = document.createElement('span');
        count.className = 'mb-unified-cart-count';
        cartLink.appendChild(count);
      }
      if (count) {
        if (cart.item_count > 0) count.textContent = String(cart.item_count);
        else count.remove();
      }
      cartLink.setAttribute('aria-label', `Winkelmandje met ${cart.item_count} artikelen`);
    });

    document.querySelectorAll('.header__icon--cart').forEach((cartLink) => {
      let bubble = cartLink.querySelector('.cart-count-bubble');
      if (cart.item_count > 0 && !bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        cartLink.appendChild(bubble);
      }
      if (bubble) {
        if (cart.item_count > 0) bubble.innerHTML = `<span aria-hidden="true">${cart.item_count}</span><span class="visually-hidden">${cart.item_count} artikelen</span>`;
        else bubble.remove();
      }
    });

    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
  };

  const add = async (button) => {
    if (button.disabled) return;
    button.disabled = true;
    button.classList.add('is-loading');
    const original = button.dataset.defaultLabel || 'Toevoegen aan winkelmandje';
    try {
      const handle = button.dataset.productHandle;
      const product = await fetch(`/products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } }).then((response) => {
        if (!response.ok) throw new Error('Product niet gevonden');
        return response.json();
      });
      const variant = product.variants.find((candidate) => candidate.available) || product.variants[0];
      if (!variant?.available) throw new Error('Tijdelijk niet beschikbaar');
      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] }),
      });
      if (!response.ok) throw new Error('Toevoegen is niet gelukt');
      button.classList.remove('is-loading');
      button.classList.add('is-added');
      button.setAttribute('aria-label', 'Toegevoegd aan winkelmandje');
      button.setAttribute('title', 'Toegevoegd');
      await updateCartLabels();
      window.setTimeout(() => {
        button.classList.remove('is-added');
        button.setAttribute('aria-label', original);
        button.setAttribute('title', original);
        button.disabled = false;
      }, 1800);
    } catch (error) {
      button.classList.remove('is-loading');
      button.classList.add('has-error');
      button.setAttribute('aria-label', error.message || 'Toevoegen is niet gelukt');
      button.setAttribute('title', error.message || 'Probeer opnieuw');
      window.setTimeout(() => {
        button.classList.remove('has-error');
        button.setAttribute('aria-label', original);
        button.setAttribute('title', original);
        button.disabled = false;
      }, 2400);
    }
  };

  const enhance = (root = document) => {
    const existingButtons = root.matches?.('[data-mb-quick-add]')
      ? [root]
      : [...root.querySelectorAll?.('[data-mb-quick-add]') || []];
    existingButtons.forEach((button) => {
      if (button.dataset.mbCleanCartIcon === 'true') return;
      enhancePriceCart(button);
      button.dataset.mbCleanCartIcon = 'true';
    });

    const standardButtons = root.matches?.('.mb-card-cart-button')
      ? [root]
      : [...root.querySelectorAll?.('.mb-card-cart-button') || []];
    standardButtons.forEach((button) => {
      if (button.dataset.mbPriceCartEnhanced === 'true') return;
      enhancePriceCart(button);
      button.dataset.mbPriceCartEnhanced = 'true';
    });
    const cards = root.matches?.('.mb-fund-slide, .mb-category-card, .mb-fund-list-card, .mb-gift-result-card, .mb-book-card, [class*="book-card"]')
      ? [root]
      : [...root.querySelectorAll?.('.mb-fund-slide, .mb-category-card, .mb-fund-list-card, .mb-gift-result-card, .mb-book-card, [class*="book-card"]') || []];
    cards.forEach((card) => {
      if (card.closest('.mb-home')) {
        card.querySelectorAll('[data-mb-quick-add]').forEach((button) => button.remove());
        return;
      }
      if (card.querySelector('[data-mb-quick-add]')) return;
      const link = card.querySelector('a[href*="/products/"]');
      const handle = link && productHandle(link.href);
      if (!handle) return;
      card.appendChild(buttonMarkup(handle));
    });

    const fundRows = root.matches?.('.mbf-row') ? [root] : [...root.querySelectorAll?.('.mbf-row') || []];
    fundRows.forEach((row) => {
      if (row.classList.contains('mbf-head') || row.querySelector('[data-mb-quick-add]')) return;
      const link = row.querySelector('.mbf-title-cell a[href*="/products/"], a[href*="/products/"]');
      const handle = link && productHandle(link.href);
      if (!handle) return;
      const button = buttonMarkup(handle);
      button.classList.add('mb-fund-row-cart');
      row.appendChild(button);
      enhancePriceCart(button);
      button.dataset.mbCleanCartIcon = 'true';
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-mb-quick-add]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    add(button);
  });

  const init = () => {
    enhance();
    const observer = new MutationObserver((mutations) => mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) enhance(node);
    })));
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => enhance(event.target));
})();
